import React from 'react';
import { FormCheck } from 'react-bootstrap';

type CheckColumnProps = {
  checked?: boolean
  onChange: () => void
};

function CheckColumn( { checked, onChange }: CheckColumnProps ) {
  return (
    <FormCheck
      className="table-check-input"
      checked={checked}
      onChange={onChange}
    />
  );
}

export default CheckColumn;
